import { render, staticRenderFns } from "./XLoadingIcon.vue?vue&type=template&id=dfdc1762&scoped=true"
import script from "./XLoadingIcon.vue?vue&type=script&lang=ts"
export * from "./XLoadingIcon.vue?vue&type=script&lang=ts"
import style0 from "./XLoadingIcon.vue?vue&type=style&index=0&id=dfdc1762&prod&lang=scss"
import style1 from "./XLoadingIcon.vue?vue&type=style&index=1&id=dfdc1762&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfdc1762",
  null
  
)

export default component.exports